export function CaretIcon({ className }: any) {
  return (
    <svg width="19" height="33" viewBox="0 0 19 33" className="w-full">
      <path d="M16.125 32.5L0 16.25L16.125 0L18.725 2.65L5.225 16.25L18.725 29.85L16.125 32.5V32.5Z" className={className ? className : 'fill-black'} />
    </svg>
  );
}
